<template>
  <div
    class="onboarding"
    @mouseenter="() => pauseInterval('mouseenter')"
    @mouseleave="() => startInterval('mouseleave')"
    v-hammer:swipe="swipe"
    v-hammer:press="() => pauseInterval('press')"
    v-hammer:pressup="() => startInterval('pressup')"
  >
    <div class="onboarding__animation">
      <div class="onboarding__animation--player">
        <lottie-player
          v-show="currentStepIndex === 0"
          :key="`lottie-player-${0}`"
          :src="steps[0].animation"
          background="transparent"
          style="width: 300px; height: 300px"
          speed="1"
          ref="lottiePlayers"
        />
        <lottie-player
          v-show="currentStepIndex === 1"
          :key="`lottie-player-${1}`"
          :src="steps[1].animation"
          background="transparent"
          style="width: 300px; height: 300px"
          speed="1"
          ref="lottiePlayers"
        />
        <lottie-player
          v-show="currentStepIndex === 2"
          :key="`lottie-player-${2}`"
          :src="steps[2].animation"
          background="transparent"
          style="width: 300px; height: 300px"
          speed="1"
          ref="lottiePlayers"
        />
      </div>
      <div class="bg-primary-svg">
        <svg
          width="303"
          height="274"
          viewBox="0 0 303 274"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M93.7866 271.794C64.6396 264.289 55.3068 227.472 40.0064 201.55C23.766 174.036 -6.45279 146.701 1.71045 115.802C10.1164 83.984 51.3901 75.6711 78.2756 56.6946C97.1045 43.4048 114.47 29.5607 135.9 21.0877C158.185 12.2767 180.893 7.57852 204.835 6.65587C236.442 5.43784 280.033 -11.5472 297.438 14.8626C316.262 43.4253 274.928 78.6506 274.833 112.867C274.765 137.354 307.839 159.392 296.974 181.34C285.828 203.856 250.63 196.753 227.955 207.564C210.433 215.918 196.845 229.045 179.337 237.427C151.044 250.971 124.155 279.614 93.7866 271.794Z"
            fill-opacity="0.3"
          />
        </svg>
      </div>
    </div>
    <h2>{{ currentStep.title }}</h2>
    <p>
      {{ currentStep.description }}
    </p>
    <ul class="step-indicator">
      <li
        v-for="(_step, index) in steps"
        :key="index"
        :class="{ active: index === currentStepIndex }"
        @click="changeStep(index)"
      />
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const SWIPE_TO_LEFT = 2;
const SWIPE_TO_RIGHT = 4;

const DESKTOP_EVENTS = ["mouseenter", "mouseleave"];
const MOBILE_EVENTS = ["press", "pressup", "swipe"];
const TIME_TO_CHANGE_STEP = 10000; // 10 seconds

export default {
  data: () => ({
    steps: [
      {
        animation:
          "https://lottie.host/5cbd5cde-e0fe-4db8-98cb-3db34b0c2e13/lVwuZnuqjJ.json",
        title:
          "Aumente suas chances de seleção para uma entrevista de emprego!",
        description:
          "Preencha suas informações e envie seu currículo para aumentar suas chances de convocação. Lembre-se de ter um perfil completo e atualizado. 😎",
      },
      {
        animation:
          "https://lottie.host/10e2bfff-2e18-4aec-9527-011179f960d8/EM9DL2BmhR.json",
        title: "Não perca oportunidades de seleção para vagas!",
        description:
          "Quando houver, responda o formulário de perguntas da vaga após a candidatura e destaque-se. Com seu cadastro bem feito uma vez só, você se candidata a quantas vagas quiser! 😉",
      },
      {
        animation:
          "https://lottie.host/c2f51f9c-ce8e-4e07-992b-6e54fd3ec21d/UX4gcs8Xhy.json",
        title: "Ganhe autoconhecimento fazendo sua análise comportamental",
        description:
          "São apenas 8 minutinhos para você entender melhor suas tendências de comunicação, extroversão ou introversão. O relatório é instantâneo, 100% gratuito e ajuda o recrutador a te entender melhor! 🤩",
      },
    ],
    currentStepIndex: 0,
    interval: null,
    startTime: null,
    stepsExecutionTime: [],
  }),
  computed: {
    ...mapGetters("company", ["color"]),

    currentStep() {
      return this.steps[this.currentStepIndex];
    },
  },
  methods: {
    changeStep(index) {
      if (this.isMobile()) return;

      this.pauseInterval();
      this.currentStepIndex = index;
      this.startInterval();

      window.woopra.track("onboarding-change-step-by-dot", {
        step_index: index,
      });
    },
    swipe(options) {
      this.pauseInterval();
      if (options.direction === SWIPE_TO_RIGHT && this.currentStepIndex > 0) {
        this.currentStepIndex = (this.currentStepIndex - 1) % this.steps.length;
        // window.woopra.track("onboarding-swipe", {
        //   swipe_direction: "right",
        // });
      }

      if (options.direction === SWIPE_TO_LEFT && this.currentStepIndex < 2) {
        this.currentStepIndex = (this.currentStepIndex + 1) % this.steps.length;
        // window.woopra.track("onboarding-swipe", {
        //   swipe_direction: "left",
        // });
      }
      this.startInterval();
    },
    playLottie(index) {
      if (!this.$refs.lottiePlayers) return;

      const player = this.$refs.lottiePlayers[index];
      if (player) player.playLottie();
    },
    startInterval(eventType) {
      if (DESKTOP_EVENTS.includes(eventType) && this.isMobile()) return;

      if (MOBILE_EVENTS.includes(eventType) && !this.isMobile()) return;

      this.interval = setInterval(
        this.changeStepByInterval,
        TIME_TO_CHANGE_STEP
      );

      if (eventType) {
        // window.woopra.track("onboarding-start-interval", {
        //   event_type: eventType,
        // });
      }
    },
    changeStepByInterval() {
      this.currentStepIndex = (this.currentStepIndex + 1) % this.steps.length;
    },
    pauseInterval(eventType) {
      if (DESKTOP_EVENTS.includes(eventType) && this.isMobile()) return;

      if (MOBILE_EVENTS.includes(eventType) && !this.isMobile()) return;

      clearInterval(this.interval);
      this.interval = null;

      if (eventType) {
        // window.woopra.track("onboarding-pause-interval", {
        //   event_type: eventType,
        // });
      }
    },
    updateTimeExecution(timeDiffInSeconds) {
      this.stepsExecutionTime[this.currentStepIndex] =
        (this.stepsExecutionTime[this.currentStepIndex] || 0) +
        timeDiffInSeconds;

      this.stepsExecutionTime.forEach((stepExecutionTime, index) => {
        if (stepExecutionTime) {
          // window.woopra.track("onboarding-steps-time-tracking", {
          //   [`step_${index}`]: stepExecutionTime,
          // });
        }
      });
    },
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  mounted() {
    this.playLottie(0);
    this.startInterval();
  },
  watch: {
    interval(value) {
      if (value) {
        this.startTime = Date.now();
      } else {
        const timeDiffInSeconds = (Date.now() - this.startTime) / 1000;

        this.updateTimeExecution(timeDiffInSeconds);
      }
    },
    currentStepIndex(value) {
      this.playLottie(value);
      this.pauseInterval();
      this.startInterval();
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding {
  z-index: 100;
  max-width: 488px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__animation {
    position: relative;

    &--player {
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
    }
  }

  .step-indicator {
    list-style-type: none;
    padding: 0;
    margin-top: 20px;
    display: flex;
    justify-content: center;

    li {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #dfe1e6;
      margin: 0 5px;
      cursor: pointer;

      @media (max-width: 1199px) {
        li {
          width: 16px;
          height: 16px;
        }
      }

      @media (max-width: 599px) {
        li {
          width: 6px;
          height: 6px;
        }
      }

      &.active {
        width: 32px;
        border-radius: 13px;
        background: #8993a4;

        @media (max-width: 599px) {
          width: 22px;
        }
      }
    }
  }

  h2 {
    color: #172b4d;
    text-align: center;
    font-family: "Roboto", sans-serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 0.52px;
    margin: 40px 0 24px 0;

    @media (max-width: 1199px) {
      margin: 30px 0 20px 0;
    }

    @media (max-width: 599px) {
      margin: 0px 0 16px 0;
    }
  }

  p {
    color: #172b4d;
    text-align: center;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.32px;
  }

  svg {
    margin-bottom: 40px;
    width: 303px;
    height: 274px;

    @media (max-width: 1199px) {
      margin-bottom: 30px;
      width: 303px;
      height: 274px;
    }

    @media (max-width: 599px) {
      margin-bottom: 20px;
      width: 280px;
      height: 232px;
    }
  }
}
</style>
